import { storeToRefs } from 'pinia';
import {
  useAppLauncherStore,
  useAppLauncherSetters,
} from './use-app-launcher-store';

export { useAppLauncherStore, useAppLauncherSetters };
export { useCommonActions } from './use-common-actions';
export { useAppLauncherRouting } from './use-app-launcher-routing';
export { useInitializeAppLauncher } from './use-initialize-app-launcher';
export { useComponentBundles } from './use-component-bundles';
export { useAppUpdate } from './use-app-update';
export { useAppUpdateTracking } from './use-app-update-tracking';
export { useAppThemeTracking } from './use-app-theme-tracking';

export const useAppLauncher = () => {
  return {
    ...storeToRefs(useAppLauncherStore()),
    ...useAppLauncherSetters(),
  };
};
